<div class="w-100 container">
  <!-- ? Header -->
  <app-makna-header
    [title]="'ساختن رمز عبور'"
    (onBackButtonClicked)="onBackClick()"
  />

  <div class="content-container w-100">
    <div class="content">
      <p class="title-insert-phone">برای حساب کاربری خود رمز عبور جدید بسازید.</p>

      <app-password-complexity
        (onPasswordChanged)="onPasswordChanged($event)"
        (onRepeatPasswordChanged)="onRepeatPasswordChanged($event)"
      />
    </div>

    <div class="footer">
      <ngx-button
        [style]="'fill'"
        [brandButton]="true"
        size="medium"
        [fullWidth]="true"
        [disabled]="
          password?.value?.length < 8 ||
          passwordRepeat?.value?.length < 8 ||
          password?.complexity < 2 ||
          passwordRepeat?.complexity < 2 ||
          loading
        "
        (clickHandler)="onNextStep()"
      >
        @if (rateLimit) {
          <ngx-count-down
            [timeInSeconds]="otpSeconds"
            [type]="'mm:ss'"
            (finished)="timerFinish()"
          ></ngx-count-down>
        } @else {
          <span class="send-again"> تایید و ادامه </span>
        }
      </ngx-button>
    </div>
  </div>
</div>
